// extracted by mini-css-extract-plugin
export var cardLayout = "_61-1";
export var paginationContainer = "_61-0";